import React, { Component } from 'react';
import { Nav, Alert, Row, Col, Modal, Button } from "react-bootstrap";

class Footer extends Component {

	constructor(props) {
        super();
        this.state = {
			showModal : false
        }
	}
	
	toggleShow = () => {
		this.setState({showModal:!this.state.showModal})
	}

	render() {
		const showModal = this.state.showModal
		
		const navs = [
            {
                label: "Home",
                url: "/"
			},
			{
                label: "Products",			
                url: "/products"
			},
			{
                label: "Videos",			
                url: "/videos"
			},
			/*{
                label: "Insights",		//Changed from Verticals to Insights
                url: "/offerings"
			},*/
			
			{
                label: "News",	//Changed from Events to News
                url: "/news"	//Changed from events to news
            },
			/*{
                label: "5G Resources",
                url: "/resources"
			},*/
			{	label: "Contact Us",
				url: "/contact"
			}
        ]		

		const mainLinks = navs.map(link => {
            return (
				<Nav.Item key={link.label} className={window.location.pathname == link.url ? 'active' : ''}>
					<Nav.Link href={link.url}>{link.label}</Nav.Link>
				</Nav.Item>
            )
        })

		return (
			<footer className="py-5">
				<div className="container">
					<div className="row">
						<div className="col-12 col-md-5">
							<h4>Let’s Stay Connected</h4>
							<div className="social-links">
								<a href="https://www.linkedin.com/company/bridge-alliance?trk=d_public_post_image" target="_blank"><i className="icon-linkedin2"></i></a>
								<a href="https://twitter.com/alliance_bridge" target="_blank"><i className="icon-twitter"></i></a>
								<a href="#" onClick={this.toggleShow}><i className="icon-wechat"></i></a>
								<a href="https://www.youtube.com/channel/UC8x25kUBx0gvDCiE5b6BxAA" target="_blank"><i className="icon-youtube"></i></a>
								{/*<a href="/faq"><i className="icon-question"></i></a>*/} {/*Commented faq icon*/}
								<a href="/contact"><i className="icon-envelope-o"></i></a> 
							</div>
							{/*<p className="text-sm">© Copyright 2019 Bridge Mobile Pte. Ltd. All Rights Reserved.</p>*/}
						</div>
						<div className="col-12 col-md-7">
							{(process.env.REACT_APP_MODE === "sandbox") && (
								<Row>
									<Col md={{ span: 4, offset: 8 }}>
										<Alert variant={"warning"}>
											Environment: Test
										</Alert>
									</Col>
								</Row>

							)}
							<Nav className="float-right">
								{mainLinks}
							</Nav>
							{/*<p className="poweredby float-right">Developed by <a href="https://www.bridgealliance.com/" target="_blank">Bridge Mobile Pte. Ltd.</a></p>*/} {/*Comments: 5G Initial Code Changes, Modified By: <Asar>, Date Modified: <2020-01-22>*/}
							<p className="poweredby float-right">© Copyright {new Date().getFullYear()} Bridge Mobile Pte. Ltd. All Rights Reserved.</p>
						</div>
					</div>
				</div>
				<Modal show={showModal} onHide={this.toggleShow}>
					<Modal.Body>
						<img className="img-fluid" src="/assets/images/qrcode_for_gh_a8b755ad17d7_860.jpg"/>
					</Modal.Body>
					<Modal.Footer>
					<Button variant="secondary" onClick={this.toggleShow}>
						Close
					</Button>
					</Modal.Footer>
				</Modal>
			</footer >
		)
	}
}

export default Footer